import type { SxProps, Theme } from '@mui/material';
import React from 'react';
import { Page } from '../../../../app/page-url-path';
import { DataElementId } from '../../../../constants/data-element-tracking-ids';
import type { IModuleWithImageData } from '../../../../dotcms/dotcms-models/dotcms-module-with-image';
import { HomepageModuleWrapper } from '../homepage-module-wrapper';
import { ModuleWithImage } from '../module-with-image';

interface IProps {
  data: IModuleWithImageData;
  muiTheme: Theme;
}

const ReachMoreModule: React.FC<IProps> = ({ data, muiTheme }) => {
  const rootStyle: SxProps<Theme> = {
    [muiTheme.breakpoints.up('desktop')]: {
      paddingBottom: '102px',
    },
  };

  return (
    <HomepageModuleWrapper dataComponentName="ReachMoreModule" sx={rootStyle}>
      <ModuleWithImage
        data={data}
        button={{
          pageForButton: {
            defaultData: Page.ABOUT_CASHLESS,
          },
          dataElementId: DataElementId.HOMEPAGE_LINK_REACH_MORE_CTA,
        }}
      />
    </HomepageModuleWrapper>
  );
};

export default ReachMoreModule;
